import { render } from "./LocatingInfo.vue?vue&type=template&id=2ddcf760&scoped=true"
import script from "./LocatingInfo.vue?vue&type=script&lang=js"
export * from "./LocatingInfo.vue?vue&type=script&lang=js"

import "./LocatingInfo.vue?vue&type=style&index=0&id=2ddcf760&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ddcf760"]])

export default __exports__